import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, onSnapshot, query, Timestamp, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import Button from '@mui/material/Button';
import { TextField, Autocomplete } from '@mui/material';
import moment from 'moment';

export default function Avakregister() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  // 🔹 States
  const [loadincount, setloadincount] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  const [products, setproducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [avakitems, setavakitems] = useState([]);
  const [username, setusername] = useState("");
  const [userData, setUserData] = useState(null);

  const [avakdate, setavakdate] = useState(moment().format('YYYY-MM-DD'));
  const [billdate, setbilldate] = useState(moment().format('YYYY-MM-DD'));
  const [alltotal, setalltotal] = useState(0);
  const [avakpersonname, setavakpersonname] = useState("");
  const [dealername, setdealername] = useState("");
  const [billno, setbillno] = useState("");
  const [materaildate, setmateraildate] = useState(moment().format('YYYY-MM-DD'));
  const [storedate, setstoredate] = useState(moment().format('YYYY-MM-DD'));
  const [billnote1, setbillnote1] = useState("");
  const [billnote2, setbillnote2] = useState("");
  const [propertyId, setPropertyId] = useState(null);

  const [rate, setrate] = useState(0);
  const [quantity, setquantity] = useState(0);
  const [size, setsize] = useState("");

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUserData(user);

        const docRef = doc(db, "authroles", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setusername(docSnap.data().username || "");
          setPropertyId(docSnap.data().propertyId || null);
        }
      }
    });

    return () => unsub();
  }, []);


  useEffect(() => {
    if (!propertyId) return;

    const q = query(
      collection(db, "departments"),
      where("propertyId", "==", propertyId)

    );

    const unsub = onSnapshot(q, (querySnapshot) => {
      setDepartments(
        querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
      );
    });

    return () => unsub();
  }, [propertyId]);


  useEffect(() => {
    if (!selectedDepartment || !propertyId) {
      setproducts([]);
      return;
    }

    const q = query(
      collection(db, "storeproducts"),
      where("propertyId", "==", propertyId),
      where("departmentid", "==", selectedDepartment.id)
    );

    const unsub = onSnapshot(q, (querySnapshot) => {
      setproducts(
        querySnapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        }))
      );
    });

    return () => unsub();
  }, [selectedDepartment, propertyId]);

  // 🔹 Add Item
  const handleAvakArray = () => {
    if (!selectedDepartment) {
      Toast.fire({ icon: "error", title: 'Please select a Department first' });
      return;
    }
    if (!selectedProduct) {
      Toast.fire({ icon: "error", title: 'Please select a Product' });
      return;
    }

    const newItem = {
      departmentid: selectedDepartment.id,
      department: selectedDepartment.department,
      productid: selectedProduct.id,
      product: selectedProduct.data.product,
      rate,
      quantity,
      size,
      username,
      propertyId
    };

    const updatedItems = [...avakitems, newItem];
    setavakitems(updatedItems);

    setSelectedProduct(null);
    setrate(0);
    setquantity(0);
    setsize("");

    const total = updatedItems.reduce(
      (sum, item) => sum + (parseFloat(item.rate || 0) * parseFloat(item.quantity || 0)),
      0
    );
    setalltotal(total);
  };

  // 🔹 Remove Item
  const removeItem = (itemToRemove) => {
    if (window.confirm(`Are you sure you want to remove this item?`)) {
      const updatedItems = avakitems.filter((item) => item !== itemToRemove);
      setavakitems(updatedItems);
      const total = updatedItems.reduce(
        (sum, item) => sum + (parseFloat(item.rate || 0) * parseFloat(item.quantity || 0)),
        0
      );
      setalltotal(total);
    }
  };

  // 🔹 Submit Data
  const submitData = async () => {
    try {
      const avakRef = await addDoc(collection(db, 'avakregisters'), {
        avakitems,
        avakdate,
        alltotal,
        avakpersonname,
        dealername,
        billno,
        billdate,
        materaildate,
        storedate,
        billnote1,
        billnote2,
        uid: userData?.uid,
        propertyId,
        createdAt: Timestamp.now(),
      });

      for (let j = 0; j < avakitems.length; j++) {
        await addDoc(collection(db, 'avakitems'), {
          avakid: avakRef.id,
          departmentid: avakitems[j].departmentid,
          department: avakitems[j].department,
          product: avakitems[j].product,
          productid: avakitems[j].productid,
          quantity: parseFloat(avakitems[j].quantity),
          size: avakitems[j].size,
          rate: avakitems[j].rate,
          uid: userData?.uid,
          username,
          createdAt: Timestamp.now(),
          avakdate,
          propertyId
        });
      }

      Toast.fire({ icon: "success", title: 'Avak Data successfully saved' });

      // reset form
      setavakitems([]);
      setalltotal(0);
      setavakpersonname('');
      setdealername('');
      setbillno('');
      setbillnote1('');
      setbillnote2('');
    } catch (error) {
      Toast.fire({ icon: "error", title: 'Error in Avak Data: ' + error.message });
    }
  };

  // 🔹 UI
  return (
    <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>
      <section className="content"><br />
        <div className="container-fluid">
          <button className="btn btn-secondary">|| Avak Register ||</button><br /><br />
          <div className='row'>
            <div className='col-sm-12'>
              <div className='card'>
                <div className="card-body">
                  <table className="table table-bordered align-middle" width="100%">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: "18%", textAlign: "center" }}>Department</th>
                        <th style={{ width: "22%", textAlign: "center" }}>Product</th>
                        <th style={{ width: "12%", textAlign: "center" }}>Quantity</th>
                        <th style={{ width: "12%", textAlign: "center" }}>Size</th>
                        <th style={{ width: "12%", textAlign: "center" }}>Rate</th>
                        <th style={{ width: "10%", textAlign: "center" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <Autocomplete
                            options={departments}
                            getOptionLabel={(option) => option.department || ""}
                            value={selectedDepartment}
                            onChange={(e, newValue) => {
                              setSelectedDepartment(newValue);
                              setSelectedProduct(null);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Department" size="small" fullWidth />
                            )}
                          />
                        </td>
                        <td>
                          <Autocomplete
                            options={products}
                            getOptionLabel={(option) => option.data.product || ""}
                            value={selectedProduct}
                            onChange={(e, newValue) => setSelectedProduct(newValue)}
                            renderInput={(params) => (
                              <TextField {...params} label="Product" size="small" fullWidth />
                            )}
                            disabled={!selectedDepartment}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                          />
                        </td>
                        <td>
                          <TextField
                            type="number"
                            value={quantity}
                            onChange={(e) => setquantity(e.target.value)}
                            size="small"
                            fullWidth
                          />
                        </td>
                        <td>
                          <TextField
                            type="text"
                            value={size}
                            onChange={(e) => setsize(e.target.value)}
                            size="small"
                            fullWidth
                          />
                        </td>
                        <td>
                          <TextField
                            type="number"
                            value={rate}
                            onChange={(e) => setrate(e.target.value)}
                            size="small"
                            fullWidth
                          />
                        </td>
                        <td className="text-center">
                          <button className="btn btn-sm btn-info" onClick={handleAvakArray}>
                            <i className="fa fa-plus"></i> Add
                          </button>
                        </td>
                      </tr>

                      {avakitems.map((item, index) => (
                        <tr key={index}>
                          <td><input type="text" readOnly value={item.department} className="form-control form-control-sm" /></td>
                          <td><input type="text" readOnly value={item.product} className="form-control form-control-sm" /></td>
                          <td><input type="text" readOnly value={item.quantity} className="form-control form-control-sm" /></td>
                          <td><input type="text" readOnly value={item.size} className="form-control form-control-sm" /></td>
                          <td><input type="text" readOnly value={item.rate} className="form-control form-control-sm" /></td>
                          <td className="text-center">
                            <button onClick={() => removeItem(item)} className="btn btn-sm btn-danger">
                              <i className="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>

          {/* Form fields same as before */}
          <div className='row'>
            <div className='col-sm-4'>
              <div className='card'>
                <div className="card-body">
                  <TextField fullWidth label="Avak Date" type="date" value={avakdate} onChange={(e) => setavakdate(e.target.value)} size="small" /><br /><br />
                  <TextField fullWidth label="All Total" value={alltotal} size="small" disabled /><br /><br />
                  <TextField fullWidth label="Avak Person Name" value={avakpersonname} onChange={(e) => setavakpersonname(e.target.value)} size="small" /><br /><br />
                </div>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className='card'>
                <div className="card-body">
                  <TextField fullWidth label="Dealer Name" value={dealername} onChange={(e) => setdealername(e.target.value)} size="small" /><br /><br />
                  <TextField fullWidth label="Bill No" value={billno} onChange={(e) => setbillno(e.target.value)} size="small" /><br /><br />
                  <TextField fullWidth label="Bill Date" type="date" value={billdate} onChange={(e) => setbilldate(e.target.value)} size="small" /><br /><br />
                </div>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className='card'>
                <div className="card-body">
                  <TextField fullWidth label="Store Material Date" type="date" value={materaildate} onChange={(e) => setmateraildate(e.target.value)} size="small" /><br /><br />
                  <TextField fullWidth label="Store Bill Add Date" type="date" value={storedate} onChange={(e) => setstoredate(e.target.value)} size="small" /><br /><br />
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-sm-6'>
              <div className='card'>
                <div className="card-body">
                  <TextField fullWidth label="Bill Note 1" value={billnote1} onChange={(e) => setbillnote1(e.target.value)} /><br /><br />
                </div>
              </div>
            </div>
            <div className='col-sm-6'>
              <div className='card'>
                <div className="card-body">
                  <TextField fullWidth label="Bill Note 2" value={billnote2} onChange={(e) => setbillnote2(e.target.value)} /><br /><br />
                </div>
              </div>
            </div>
          </div>

          <center>
            <Button variant="contained" onClick={submitData}>Submit</Button>
          </center>
        </div>
      </section>
    </div>
  )
}
